import React from "react";
import { historyShape } from "./shapes";
import PT from "prop-types";
import { HistoryItem, Avatar, Link, HistorySect, Title } from "./index-styled";
import { generateAvatar } from "@/utils";
import { LinkGenerator } from "@/utils/LinkGenerator";

const History = props => (
  <HistorySect>
    <Title>{props.t("client_profile:watch")}</Title>
    <ul>
      {props.history.map(({ _id, first_name, sex, last_name, avatar }) => (
        <HistoryItem key={_id}>
          <Link to={LinkGenerator.masterProfile(_id)}>
            <Avatar src={generateAvatar({ url: avatar, sex })} />
            <span>{[first_name, last_name].filter(Boolean).join(" ")}</span>
          </Link>
        </HistoryItem>
      ))}
    </ul>
  </HistorySect>
);
History.propTypes = {
  history: PT.arrayOf(historyShape)
};

export default History;
